module.exports = __webpack_public_path__ + "static/media/conceptposter.3ead96cf.pdf";